// src/utils/post-auth.ts
export const POSTAUTH_KEY = 'diffsona:postAuth:intent';

export function savePostAuthIntent(intent: any) {
  sessionStorage.setItem(POSTAUTH_KEY, JSON.stringify(intent));
}

export function takePostAuthIntent<T = any>(): T | null {
  const raw = sessionStorage.getItem(POSTAUTH_KEY);
  if (!raw) return null;
  sessionStorage.removeItem(POSTAUTH_KEY);
  try { return JSON.parse(raw) as T; } catch { return null; }
}

// compact base64url
export function encodeState(obj: any) {
  const s = JSON.stringify(obj);
  return btoa(unescape(encodeURIComponent(s))).replace(/\+/g,'-').replace(/\//g,'_').replace(/=+$/,'');
}
export function decodeState<T=any>(s: string): T | null {
  try {
    const pad = s.length % 4 ? s + '===='.slice(s.length % 4) : s;
    const json = decodeURIComponent(escape(atob(pad.replace(/-/g,'+').replace(/_/g,'/'))));
    return JSON.parse(json) as T;
  } catch { return null; }
}

export const DEMO_LS_KEY = 'diffsona:demo:current';
